module.exports = __webpack_public_path__ + "static/assets/ea3cb3c5a2a4ea9d4bc4e29eb7c09cb7.jpg";